const en = {
  idCardReadTimeout: 'Reading the ID card took too long. Please close all the open browser windows and then try again.',
};

export default en;
